// Helpers extraits du proto Modules/12M Cash/treso_v9.jsx (lignes 152-211, 437-445).
// VERBATIM — fonctions de formatage et utilitaires de période.

import { MOIS_COURT } from './constants';

export const uid = () => Math.random().toString(36).substr(2, 9);
export const sum = (arr) => Array.isArray(arr) ? arr.reduce((a, b) => a + (Number(b) || 0), 0) : 0;

// Format suisse avec apostrophes pour les milliers
export const fmt = (n) => {
  if (n === null || n === undefined || isNaN(n)) return '—';
  if (Math.abs(n) < 0.5) return '0';
  const sign = n < 0 ? '-' : '';
  return sign + Math.abs(Math.round(n)).toLocaleString('fr-CH').replace(/ |\s/g, "'");
};
export const fmtK = (n) => {
  if (Math.abs(n) < 1000) return Math.round(n).toString();
  return fmt(Math.round(n / 1000)) + 'k';
};
export const fmtM = (n) => {
  if (Math.abs(n) < 1000) return Math.round(n).toString();
  if (Math.abs(n) < 1000000) return fmtK(n);
  return (n / 1000000).toFixed(2) + 'M';
};

export const BLUE = '#2563EB';
export const parseMontant = (str) => {
  if (typeof str === 'number') return str;
  if (!str) return 0;
  const cleaned = String(str).replace(/['\s  ]/g, '').replace(',', '.');
  const n = parseFloat(cleaned);
  return isNaN(n) ? 0 : n;
};

export const seasonalityIndex = (valeurs) => {
  if (!Array.isArray(valeurs) || valeurs.length === 0) return 0;
  const total = sum(valeurs);
  if (total === 0) return 0;
  const moy = total / 12;
  const variance = valeurs.reduce((a, v) => a + Math.pow((Number(v) || 0) - moy, 2), 0) / 12;
  return (Math.sqrt(variance) / moy) * 100;
};

// Traduit un mois calendaire (0=Janv ... 11=Déc) en index horizon, ou null si hors plage.
export const calToHorizon = (moisCal, moisDebut, H) => {
  if (typeof moisCal !== 'number' || moisCal < 0 || moisCal > 11) return null;
  let idx = moisCal - (moisDebut || 0);
  if (idx < 0) idx += 12;
  return idx < H ? idx : null;
};

export const horizonCouvreDecembre = (moisDebut, H) => calToHorizon(11, moisDebut, H) !== null;

// Libellé "Jan 2026" pour un index horizon donné.
export const monthLabel = (idx, moisDebut, anneeDebut) => {
  const moisIdx = (moisDebut + idx) % 12;
  const annee = anneeDebut + Math.floor((moisDebut + idx) / 12);
  return `${MOIS_COURT[moisIdx]} ${annee}`;
};
